import { ShieldCheck, Globe2, Users, Landmark } from "lucide-react";
import { useLang } from "@/LangContext";
import { Reveal, Chapter } from "@/components/Reveal";

const ICONS = [ShieldCheck, Globe2, Users, Landmark];

export default function Governance() {
  const { t } = useLang();

  return (
    <section
      id="gobernanza"
      data-testid="governance-section"
      className="relative border-t border-white/5 bg-[#0C0F16] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter number={t.gov.chapter} label={t.gov.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-display text-3xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
            {t.gov.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            {t.gov.subtitle}
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {t.gov.features.map((f, i) => {
            const Icon = ICONS[i];
            const highlight = i === 1;
            return (
              <div
                key={f.title}
                data-testid={`governance-feature-${i + 1}`}
                className={`group p-7 transition-colors duration-500 sm:p-8 ${
                  highlight
                    ? "bg-[#151A24]"
                    : "bg-[#0C0F16] hover:bg-[#121620]"
                }`}
              >
                <div
                  className={`flex h-12 w-12 items-center justify-center border transition-colors duration-500 ${
                    highlight
                      ? "border-amber-400/60 text-amber-400"
                      : "border-white/15 text-slate-400 group-hover:border-amber-400/50 group-hover:text-amber-400"
                  }`}
                >
                  <Icon size={20} />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold uppercase leading-tight text-white">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
